import { render, staticRenderFns } from "./EcommerceBrowserStates.vue?vue&type=template&id=089da96e&"
import script from "./EcommerceBrowserStates.vue?vue&type=script&lang=js&"
export * from "./EcommerceBrowserStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('089da96e')) {
      api.createRecord('089da96e', component.options)
    } else {
      api.reload('089da96e', component.options)
    }
    module.hot.accept("./EcommerceBrowserStates.vue?vue&type=template&id=089da96e&", function () {
      api.rerender('089da96e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/ecommerce/EcommerceBrowserStates.vue"
export default component.exports